import React from 'react';
import { Button } from '@/components/ui/button';
import { Telescope, Route } from 'lucide-react';

export type TabType = 'visits' | 'tours';

interface NavigationTabsProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  isCompact?: boolean;
}

const NavigationTabs: React.FC<NavigationTabsProps> = ({
  activeTab,
  onTabChange,
  isCompact = false
}) => {
  return (
    <div className={`w-full bg-white transition-all duration-300 ${
      isCompact ? 'px-4 py-2' : 'px-6 py-3 border-b border-gray-200'
    }`}>
      <div className={`flex justify-center transition-all duration-300 ${
        isCompact ? 'gap-6' : 'gap-8'
      }`}>
        <Button
          variant="ghost"
          onClick={() => onTabChange('visits')}
          className={`transition-all duration-300 rounded-none border-b-2 hover:scale-105 ${
            isCompact 
              ? 'flex items-center gap-1 px-3 py-2 h-auto'
              : 'flex flex-col items-center gap-2 p-4 h-auto'
          } ${
            activeTab === 'visits' 
              ? 'border-black text-black' 
              : 'border-transparent text-gray-600 hover:text-gray-900'
          }`}
        >
          {!isCompact && <Telescope className="w-7 h-7" />}
          <span className={`font-semibold transition-all duration-300 ${
            isCompact ? 'text-xs' : 'text-sm'
          }`}>
            Visits
          </span>
        </Button>
        
        <Button
          variant="ghost"
          onClick={() => onTabChange('tours')}
          className={`transition-all duration-300 rounded-none border-b-2 hover:scale-105 ${
            isCompact 
              ? 'flex items-center gap-1 px-3 py-2 h-auto'
              : 'flex flex-col items-center gap-2 p-4 h-auto'
          } ${
            activeTab === 'tours' 
              ? 'border-black text-black' 
              : 'border-transparent text-gray-600 hover:text-gray-900'
          }`}
        >
          {!isCompact && <Route className="w-7 h-7" />}
          <span className={`font-semibold transition-all duration-300 ${
            isCompact ? 'text-xs' : 'text-sm'
          }`}>
            Tours
          </span>
        </Button>
      </div>
    </div>
  );
};

export default NavigationTabs;